export default __webpack_public_path__ + "static/media/PlayStoreBadge.9bc7f6a6.png";